export enum EMaritalStatus {
  Single = 1,
  Married = 2,
  Divorced = 3,
  Widowed = 4,
  Other = 5,
}

export const EMaritalStatusLabel = {
  [EMaritalStatus.Single]: 'Belum Kawin',
  [EMaritalStatus.Married]: 'Kawin',
  [EMaritalStatus.Divorced]: 'Cerai Hidup',
  [EMaritalStatus.Widowed]: 'Cerai Mati',
  [EMaritalStatus.Other]: 'Lainnya',
};

export const EMaritalStatusEnglishLabel = {
  [EMaritalStatus.Single]: 'Single',
  [EMaritalStatus.Married]: 'Married',
  [EMaritalStatus.Divorced]: 'Divorced',
  [EMaritalStatus.Widowed]: 'Widowed',
  [EMaritalStatus.Other]: 'Other',
};
